const mutations = {
  setSettingList(state, payload) {
    state.setting_list = payload;
  },
};

export default mutations;
